<template>
  <div class="menu-page single-page page">
    <div>
      <dashboard-nav></dashboard-nav>
      <div class="d-flex bodyWrapper">
        <div class="nav-view">
          <main-nav></main-nav>
        </div>

        <!-- VIEW START -->
        <div class="main-view" v-if="dataReady">
          <breadcrumb></breadcrumb>
          <div class="intro-wrapper main-x-spacing">
            <v-row>
              <v-col cols="4">
                <h2 class="filter-div-title">{{ title }}</h2>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="searchQuery"
                  prepend-inner-icon="search"
                  label="Search Locations"
                  class="toWhite"
                  flat
                  hide-details
                  single-line
                  solo
                ></v-text-field>
              </v-col>
              <v-col cols="2">
                <v-btn
                  :ripple="false"
                  @click="openLocationDialog"
                  depressed
                  class="gen-button white--text"
                  color="#60a45f"
                >
                  <v-icon>add</v-icon>
                  <span>Add New Location</span>
                </v-btn>
              </v-col>
            </v-row>
          </div>
          <!-- main view -->
          <div class="main-body-content main-x-spacing">
            <v-row>
              <v-col
                cols="4"
                v-for="(location, index) in filteredSearchResult"
                :key="index"
              >
                <router-link :to="'/locations/' + location.id">
                  <div class="location-display">
                    <div class="location-display-title">
                      <h3 class="card-h3">{{ location.locationName }}</h3>
                    </div>
                    <v-img
                      :src="
                        location.locationImage ||
                        require('@/assets/imgUpload.jpg')
                      "
                      height="220px"
                      class="mb-2"
                    ></v-img>
                    <p class="card-p">
                      <span>{{ location.addressLineOne + "," }}</span>
                      <span v-if="location.addressLineTwo">
                        <br />
                        {{ location.addressLineTwo }}
                      </span>
                      <span v-if="location.city">
                        {{ ", " + location.city }}
                      </span>
                      <span v-if="location.country">
                        <br />
                        {{ location.country + "." }}
                      </span>
                    </p>
                  </div>
                </router-link>
              </v-col>
              <v-col cols="4">
                <div class="location-display">
                  <div class="location-display-center">
                    <v-icon class="icon" @click="openLocationDialog"
                      >mdi-plus-circle</v-icon
                    >
                    <p><strong>Add New Location</strong></p>
                  </div>
                </div>
              </v-col>
            </v-row>
          </div>
          <!-- Upload List -->
          <v-row justify="center" class="openDialogWrapper">
            <v-dialog
              v-model="openDialog"
              fullscreen
              scrollable
              max-width="50%"
              transition="scroll-x-reverse-transition"
              class="openDialog"
            >
              <v-card
                max-width="50%"
                tile
                class="ml-auto dialogCard"
                height="100%"
              >
                <div v-if="addNewLocationActive" class="formLayerCard">
                  <h2 class="dialog-form-title">Add a New Location</h2>
                  <v-form ref="dialogForm" class="dialog-form">
                    <div class="form-group">
                      <v-row>
                        <v-col cols="3">
                          <span class="form-span">Name:</span>
                        </v-col>
                        <v-col cols="9">
                          <v-text-field
                            v-model="locationName"
                            hide-details
                            placeholder="e.g Lekki"
                            height="25"
                            :rules="[rules.required]"
                            outlined
                            dense
                            required
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </div>
                    <div class="form-group">
                      <v-row>
                        <v-col cols="3">
                          <span class="form-span">Address:</span>
                        </v-col>
                        <v-col cols="9">
                          <v-text-field
                            v-model="addressLineOne"
                            hide-details
                            height="25"
                            :rules="[rules.required]"
                            outlined
                            dense
                            required
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </div>
                    <div class="form-group">
                      <v-row>
                        <v-col cols="3">
                          <span class="form-span">Address2:</span>
                        </v-col>
                        <v-col cols="9">
                          <v-text-field
                            v-model="addressLineTwo"
                            hide-details
                            height="25"
                            outlined
                            dense
                            required
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </div>
                    <div class="form-group">
                      <v-row>
                        <v-col cols="3">
                          <span class="form-span">City:</span>
                        </v-col>
                        <v-col cols="9">
                          <v-text-field
                            v-model="city"
                            hide-details
                            placeholder="e.g New Delhi"
                            height="25"
                            :rules="[rules.required]"
                            outlined
                            dense
                            required
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </div>
                    <div class="form-group">
                      <v-row>
                        <v-col cols="3">
                          <span class="form-span">Time Zone:</span>
                        </v-col>
                        <v-col cols="9">
                          <v-select
                            outlined
                            v-model="timeZone"
                            hide-details
                            :items="getTimeZone"
                            :menu-props="{ offsetY: true }"
                            dense
                            height="32"
                            label="Select Time Zone"
                            :rules="[rules.required]"
                            required
                          ></v-select>
                        </v-col>
                      </v-row>
                    </div>
                    <div class="form-group">
                      <v-row>
                        <v-col cols="3">
                          <span class="form-span">Currency:</span>
                        </v-col>
                        <v-col cols="9">
                          <v-select
                            outlined
                            v-model="currency"
                            hide-details="auto"
                            :rules="[rules.required]"
                            :items="allEntCurrencies"
                            item-text="name"
                            item-value="id"
                            :menu-props="{ offsetY: true }"
                            dense
                            label="Currency"
                            class="v-text-field"
                            required
                          ></v-select>
                        </v-col>
                      </v-row>
                    </div>
                    <div class="form-group">
                      <v-row>
                        <v-col cols="3">
                          <span class="form-span">Telephone Number:</span>
                        </v-col>
                        <v-col cols="9">
                          <v-text-field
                            v-model="telephoneNumber"
                            hide-details="auto"
                            label=""
                            height="25"
                            :rules="[rules.required, rules.numberMax15]"
                            outlined
                            dense
                            required
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </div>
                    <div class="form-group">
                      <v-row>
                        <v-col cols="3">
                          <span class="form-span">Location Image:</span>
                        </v-col>
                        <v-col cols="9">
                          <div class="d-flex align-end">
                            <div
                              v-if="isSelected == false"
                              class="uploadHolder uploadPreview mb-2"
                            ></div>
                            <div v-if="isSelected == true">
                              <v-img
                                contain
                                class="uploadSrc"
                                max-height="200"
                                max-width="200"
                                :src="url"
                              ></v-img>
                            </div>

                            <div class="ml-4">
                              <div>
                                <div class="uploadButtonWrapper v-btn">
                                  <v-file-input
                                    v-model="image"
                                    @change="previewImage"
                                    @click:clear="clearSelected"
                                    color="black"
                                    hide-details
                                    placeholder="Upload File"
                                    class="text-capitalize uploadButton"
                                    flat
                                    solo
                                    prepend-icon="undefined"
                                    prepend-inner-icon="publish"
                                    :rules="[rules.required]"
                                  >
                                    <template v-slot:selection="{ text }">
                                      <v-chip small label color="primary">
                                        {{ text }}
                                      </v-chip>
                                    </template>
                                  </v-file-input>
                                </div>

                                <span class="ml-4">No File Chosen</span>
                              </div>
                              <div class="caption">
                                Accepts JPG and PNG files only.
                              </div>
                            </div>
                          </div>
                        </v-col></v-row
                      >
                    </div>
                  </v-form>
                  <div class="dialogAction text-right">
                    <v-btn
                      @click="
                        openDialog = false;
                        emptyForm;
                      "
                      class="grey--text mr-3"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      class="primary"
                      :loading="loader"
                      @click="addNewLocation"
                      >Save</v-btn
                    >
                  </div>
                </div>
              </v-card>
            </v-dialog>
          </v-row>
        </div>
        <inner-page-loader v-else class="main-view"></inner-page-loader>
      </div>
    </div>

    <!-- Snackbar Notification -->
    <v-snackbar
      class="snackbar"
      :color="snackBar.color"
      bottom
      right
      v-model="snackBar.active"
      :multi-line="snackBar.multiLine"
      :timeout="snackBar.timeout"
      >{{ snackBar.text }}</v-snackbar
    >
  </div>
</template>

<script>
import dashboard_Nav from "@/components/dashboard-nav";
import bread_crumb from "@/components/breadcrumb";
import inner_page_loader from "@/components/innerPageLoader";
import main_Nav from "@/components/mainNav";
import all_countries from "../../utils/countries.json";
import { mapState } from "vuex";
import axios from "axios";
export default {
  data() {
    return {
      title: "Locations",
      dataReady: false,
      isSelected: false,
      loader: false,
      openDialog: false,
      addNewLocationActive: false,
      image: null,
      countries: all_countries,
      filteredCountries: [],
      date: new Date(),
      locationName: "",
      addressLineOne: "",
      addressLineTwo: "",
      city: "",
      timeZone: "",
      getTimeZone: "",
      currency: "",
      telephoneNumber: "",
      rules: {
        required: (value) => !!value || "Required",
        number: (value) => !value || /^[0-9]*$/.test(value) || "Invalid value",
        numberMax15: (value) =>
          !value ||
          (/^[0-9]*$/.test(value) && value.length < 16) ||
          "Must by phone digit (Max. 15)",
      },
      snackBar: {
        active: false,
        text: "",
        color: "",
        multiLine: "",
        timeout: null,
      },
      searchQuery: "",
    };
  },
  methods: {
    previewImage() {
      if (this.image) {
        this.isSelected = true;
        this.url = URL.createObjectURL(this.image);
      }
    },
    clearSelected() {
      this.isSelected = false;
      this.url = "";
    },
    openLocationDialog() {
      this.addNewLocationActive = true;
      this.openDialog = true;
    },
    addNewLocation() {
      const location = new FormData();

      location.append("locationName", this.locationName);
      location.append("addressLineOne", this.addressLineOne);
      if (this.addressLineTwo.length) {
        location.append("addressLineTwo", this.addressLineTwo);
      }
      location.append("city", this.city);
      location.append("timeZone", this.timeZone);
      location.append("currencyId", this.currency);
      location.append("phone", this.telephoneNumber);

      if (this.image) {
        location.append("locationImage", this.image);
      }
      //   Start Loader
      this.loader = true;

      axios
        .post("/api/v1/location", location, {
          headers: { Authorization: this.$store.state.token },
        })
        .then(() => {
          this.addNewLocationActive = false;
          this.openDialog = false;
          this.emptyForm();

          // Repopulate locations
          this.$store.dispatch("getEnterpriseDetails");

          //   Stop Loader
          this.loader = false;
        })
        .catch((error) => {
          // this.addNewModifierGroupActive = false;
          // this.openDialog = false;
          // this.emptyForm();

          this.snackBar.active = true;
          this.snackBar.text =
            error.response.data.message || "Error adding Location";
          this.snackBar.color = "error";
          this.snackBar.timeout = this.$store.state.snackBarDuration;

          //   Stop Loader
          this.loader = false;
        });
    },
    emptyForm() {
      this.locationName = "";
      this.addressLineOne = "";
      this.addressLineTwo = "";
      this.city = "";
      this.timeZone = "";
      this.currency = "";
      this.telephoneNumber = "";
      this.image = [];
    },
  },
  watch: {
    enterpriseLocations(val) {
      if (val) {
        // stop page loader when data is ready
        this.dataReady = true;
      }
    },
  },
  created() {
    this.$store.dispatch("getAllCurrencies");

    var data = this.countries;
    var newData = this.filteredCountries;
    data.forEach((item) => {
      newData.push(item.name);
    });

    this.$store.dispatch("getTimeZones").then((response) => {
      this.getTimeZone = response.data;
    });
    this.$store.dispatch("getIPtimeZones").then((response) => {
      this.timeZone = response.data.timezone;
    });
  },
  computed: {
    filteredSearchResult() {
      return this.enterpriseLocations.filter((item) => {
        if (
          item.locationName
            .toLowerCase()
            .indexOf(this.searchQuery.toLowerCase()) !== -1 || // search by name
          item.addressLineOne
            .toLowerCase()
            .indexOf(this.searchQuery.toLowerCase()) !== -1 // search by address line one
        ) {
          return item;
        }
      });
    },
    ...mapState(["mainNav", "enterpriseLocations", "allEntCurrencies"]),
  },
  components: {
    "dashboard-nav": dashboard_Nav,
    "main-nav": main_Nav,
    breadcrumb: bread_crumb,
    "inner-page-loader": inner_page_loader,
  },
};
</script>

<style scoped>
.uploadPreview {
  width: 200px;
  height: 200px;
}

.filter-div-title {
  margin-left: 6%;
}

.icon {
  font-size: 60px;
}

.dialog-location-img {
  width: 100px;
}
</style>
